// keep them as the first lines
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'core-js';

import svg4everybody from 'svg4everybody';
import React from 'react';
import ReactDOM from 'react-dom';
import WebfontLoader from '@dr-kobros/react-webfont-loader';

import apollo from './services/apollo';
import configureStore from './reducers/configureStore';
import { unregister } from './registerServiceWorker';
import App from './components/App';
import { useLocale as locale } from './reducers/locale';
import { getViewerLocale } from './services/locale/ViewerLocale';

const webFontConfig = {
  google: {
    families: ['Noto Sans:400,700', 'Noto Sans UI:400,700', 'Noto Sans JP:300,400,700'],
  },
};

const webFontCallback = (status) => {
  console.warn(`WebFontLoader: ${status}`);
};

// Polyfill for SVG
svg4everybody();
// opt out of cache until we have a strategy for this
unregister();

const myStore = configureStore();
// initialize the store with american english and the detected locale
const viewerLocale = getViewerLocale();

if (viewerLocale) {
  myStore.dispatch(locale(viewerLocale));
} else {
  myStore.dispatch(locale('en-US'));
}

ReactDOM.render(
  <WebfontLoader config={webFontConfig} onStatus={webFontCallback}>
    <App store={myStore} client={apollo} />
  </WebfontLoader>,
  document.getElementById('root'),
);
